import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faSlidersH, faThumbsUp, faUsers } from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';
import AZ from '../../assets/logos/logo2.png';

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    }
  }
};

const itemVariants = {
  hidden: { 
    opacity: 0, 
    y: 30, 
    rotateY: -45, 
    scale: 0.8,
    filter: 'blur(5px)'
  },
  visible: { 
    opacity: 1, 
    y: 0, 
    rotateY: 0, 
    scale: 1, 
    filter: 'blur(0px)',
    transition: { 
      duration: 0.8, 
      ease: [0.17, 0.67, 0.83, 0.67],
      type: "spring",
      stiffness: 40
    } 
  },
  hover: {
    y: -10,
    boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
    background: 'linear-gradient(145deg, rgba(255,255,255,0.15), rgba(255,255,255,0.05))',
    transition: { duration: 0.3 }
  }
};

const textVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const FeaturesSection = () => {
  return (
    <section
      id="ts-features"
      className="ts-features py-2"
      style={{
        backgroundImage: 'url(images/assets/ban4.jpg)',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center',
        color: '#fff',
        position: 'relative',
        overflow: 'hidden'
      }}
    >

         <div className="particles">
              {[...Array(20)].map((_, i) => (
                <div 
                  key={i}
                  className="particle"
                  style={{
                    width: `${Math.random() * 10 + 3}px`,
                    height: `${Math.random() * 10 + 3}px`,
                    top: `${Math.random() * 100}%`,
                    left: `${Math.random() * 100}%`,
                    animationDelay: `${Math.random() * 5}s`,
                    animationDuration: `${Math.random() * 10 + 5}s`
                  }}
                />
              ))}
            </div>
      {/* Effet de particules */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23f8c851' fill-opacity='0.15' fill-rule='evenodd'/%3E%3C/svg%3E")`,
        opacity: 0.4,
        zIndex: 0
      }}></div>
      
      <div className="container position-relative" style={{ zIndex: 10 }}>
        <div className="row justify-content-center">
          {/* Logo animé avec effet de lumière */}
          <div className="col-lg-8 text-center mb-6">
            <motion.div
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{ 
                opacity: 1, 
                scale: 1,
                rotateY: [0, 15, -15, 0],
              }}
              transition={{ 
                duration: 1.5, 
                delay: 0.2,
                rotateY: { 
                  duration: 8, 
                  repeat: Infinity, 
                  repeatType: "mirror" 
                }
              }}
              viewport={{ once: true, margin: "-100px" }}
              style={{
                display: 'inline-block',
                position: 'relative',
                padding: '20px'
              }}
            >
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'radial-gradient(circle, rgba(248,200,81,0.4) 0%, transparent 70%)',
                borderRadius: '50%',
                filter: 'blur(10px)',
                zIndex: -1,
                animation: 'pulse 4s infinite'
              }}></div>
              <motion.img
                loading="lazy"
                className="img-fluid"
                src={AZ}
                alt="service-avatar-image"
                style={{ maxWidth: '280px' }}
                whileHover={{ 
                  scale: 1.05,
                  filter: 'drop-shadow(0 0 15px rgba(248, 200, 81, 0.7))'
                }}
                transition={{ duration: 0.3 }}
              />
            </motion.div>
          </div>
        </div>

        <div className="row mt-0">
          {/* Left Column */}
          <div className="col-lg-6">
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
              variants={textVariants}
              className="ts-intro mb-5"
            >
              <motion.h3 
                className="mb-4"
                style={{ 
                  fontFamily: "'Playfair Display', serif", 
                  fontWeight: 700, 
                  fontSize: '2.2rem',
                  position: 'relative',
                  display: 'inline-block'
                }}
              >
                <span style={{
                  position: 'absolute',
                  bottom: '-10px',
                  left: 0,
                  width: '80px',
                  height: '4px',
                  background: '#f8c851',
                  borderRadius: '2px'
                }}></span>
                Qui sommes-nous
              </motion.h3>
              <motion.p 
                className='mb-0'
                variants={textVariants}
                style={{ 
                  fontSize: '1.1rem', 
                  fontFamily: "'Montserrat', sans-serif", 
                  lineHeight: 1.8,
                  fontWeight: 500,
                  color:'#000',
                  letterSpacing: '0.3px'
                }}
              >
              GEKAS Security and Consulting SARL est une entreprise de sécurité privée dynamique basée à Kinshasa, 
              spécialisée dans la protection des biens, la sécurisation des sites sensibles, la protection rapprochée, 
              ainsi que dans le conseil stratégique en sûreté et sécurité.Nous nous appuyons sur :
              </motion.p>
            </motion.div>

            {/* Features */}
            <motion.div
              className="row"
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
            >
              {[
                { 
                  icon: faTrophy, 
                  title: "Réputation d'excellence",
                  description: "Des méthodes modernes de surveillance,"
                },
                { 
                  icon: faSlidersH, 
                  title: "Partenariats solides",
                  description: "Une collaboration étroite avec les forces publiques."
                },
                { 
                  icon: faThumbsUp, 
                  title: "Notre devise ",
                  description: "Intégrité, Professionnalisme, Performance."
                },
                { 
                  icon: faUsers, 
                  title: "Équipe de professionnels",
                  description: "Une équipe d’agents hautement qualifiés,"
                }
              ].map((item, index) => (
                <motion.div 
                  className="col-md-6 mb-4" 
                  key={index} 
                  variants={itemVariants}
                  whileHover="hover"
                >
                  <div
                    className="p-4 h-100"
                    style={{
                      background: 'rgba(10, 25, 47, 0.4)',
                      borderRadius: '16px',
                      backdropFilter: 'blur(12px)',
                      boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                      border: '1px solid rgba(255,255,255,0.08)',
                      transform: 'perspective(1000px)',
                      transformStyle: 'preserve-3d',
                      transition: 'all 0.4s ease',
                      cursor: 'pointer',
                      minHeight: '140px'
                    }}
                  >
                    <div className="d-flex">
                      <motion.span 
                        className="me-4"
                        whileHover={{ scale: 1.2, rotate: 10 }}
                        style={{ color: '#f8c851', alignSelf: 'flex-start' }}
                      >
                        <FontAwesomeIcon icon={item.icon} size="2x" />
                      </motion.span>
                      <div>
                        <h5 
                          style={{ 
                            margin: '0 0 8px 0', 
                            fontFamily: "'Playfair Display', serif",
                            fontWeight: 600
                          }}
                        >
                          {item.title}
                        </h5>
                        <p 
                          style={{
                            fontSize: '0.9rem',
                            margin: 0,
                            fontFamily: "'Montserrat', sans-serif",
                            fontWeight: 300,
                            opacity: 0.9
                          }}
                        >
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>

          {/* Right Column */}
          <div 
          className="col-lg-6 mt-5 mt-lg-0">
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
              variants={textVariants}
            >
              <motion.h3 
                className="mb-4"
                style={{ 
                  fontFamily: "'Playfair Display', serif", 
                  fontWeight: 700, 
                  fontSize: '2.2rem',
                  position: 'relative',
                  display: 'inline-block'
                }}
              >
                <span style={{
                  position: 'absolute',
                  bottom: '-10px',
                  left: 0,
                  width: '80px',
                  height: '4px',
                  background: '#f8c851',
                  borderRadius: '2px'
                }}></span>
                Vision
              </motion.h3>
              <motion.p 
                className='mb-5'
                variants={textVariants}
                style={{ 
                  fontSize: '1.1rem', 
                  fontFamily: "'Montserrat', sans-serif", 
                  lineHeight: 1.8,
                  fontWeight: 500,
                  color:'#000',
                  letterSpacing: '0.3px'
                }}
              >
               GEKAS s’engage à fournir des services de haute qualité, fondés sur l’intégrité, le professionnalisme et l’innovation.
Conscients de l’importance cruciale de la sécurité dans le secteur minier en RDC, nous développons des solutions visant à réduire les risques tout en maximisant la productivité de nos clients.
Nous nous inscrivons dans la vision de Son Excellence Félix Antoine Tshisekedi Tshilombo, Président de la République, qui prône la création d’emplois comme levier de lutte contre le chômage, la faim et la pauvreté.
              </motion.p>
            </motion.div>

            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
              variants={textVariants}
              transition={{ delay: 0.2 }}
            >
              <motion.h3 
                className="mb-4"
                style={{ 
                  fontFamily: "'Playfair Display', serif", 
                  fontWeight: 700, 
                  fontSize: '2.2rem',
                  position: 'relative',
                  display: 'inline-block'
                }}
              >
                <span style={{
                  position: 'absolute',
                  bottom: '-10px',
                  left: 0,
                  width: '80px',
                  height: '4px',
                  background: '#f8c851',
                  borderRadius: '2px'
                }}></span>
                Notre mission
              </motion.h3>
              <motion.p 
                variants={textVariants}
                style={{ 
                  fontSize: '1.1rem', 
                  fontFamily: "'Montserrat', sans-serif", 
                  lineHeight: 1.8,
                  fontWeight: 500,
                  color:'#000',
                  letterSpacing: '0.3px'
                }}
              >
                Notre mission est de nous implanter sur l’ensemble du territoire national 
                et d’employer un maximum de jeunes Congolais, longtemps marginalisés par le chômage, 
                afin de contribuer à la stabilité sociale et au développement du pays.
              </motion.p>
            </motion.div>

             <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
              variants={textVariants}
              transition={{ delay: 0.2 }}
            >
              <motion.h3 
                className="mb-4"
                style={{ 
                  fontFamily: "'Playfair Display', serif", 
                  fontWeight: 700, 
                  fontSize: '2.2rem',
                  position: 'relative',
                  display: 'inline-block'
                }}
              >
                <span style={{
                  position: 'absolute',
                  bottom: '-10px',
                  left: 0,
                  width: '80px',
                  height: '4px',
                  background: '#f8c851',
                  borderRadius: '2px'
                }}></span>
               Objectif
              </motion.h3>
              <motion.p 
                variants={textVariants}
                style={{ 
                  fontSize: '1.1rem', 
                  fontFamily: "'Montserrat', sans-serif", 
                  lineHeight: 1.8,
                  fontWeight: 500,
                  color:'#000',
                  letterSpacing: '0.3px'
                }}
              >
               Nous nous engageons à assurer la sécurité et la tranquillité d’esprit de nos clients en leur 
               offrant des solutions personnalisées, soutenues par une logistique moderne et de la dernière génération.
              </motion.p>
            </motion.div>

            {/* Signature */}
            <motion.div
              className="mt-6 pt-4"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <p 
                style={{
                  fontFamily: "'Dancing Script', cursive",
                  fontSize: '1.8rem',
                  color: '#000',
                  textAlign: 'right',
                  margin: 0
                }}
              >
                L'équipe GEKAS
              </p>
              <div style={{
                height: '2px',
                background: 'linear-gradient(90deg, transparent,rgb(49, 48, 47))',
                marginTop: '-10px'
              }}></div>
            </motion.div>
          </div>
        </div> 
      </div>

      {/* CSS intégré */}
      <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800&family=Montserrat:wght@300;400;500;600&family=Dancing+Script:wght@700&display=swap');
        
        .ts-features {
          padding: 6rem 0;
        }
        
        .mb-6 {
          margin-bottom: 4rem;
        }
        
        .mt-6 {
          margin-top: 4rem;
        }
        
        @keyframes pulse {
          0% { opacity: 0.3; transform: scale(0.9); }
          50% { opacity: 0.5; transform: scale(1.1); }
          100% { opacity: 0.3; transform: scale(0.9); }
        }
        
        @media (max-width: 992px) {
          .ts-features {
            padding: 4rem 0;
          }
          
          .mb-6, .mt-6 {
            margin-bottom: 2rem;
            margin-top: 2rem;
          }
        }
      `}</style>
    </section>
  );
};

export default FeaturesSection;